import React, { useEffect, useState } from "react";
import Navbar from "../Components/Core/Navbar.jsx";
import { useNavigate } from "react-router-dom";
import Footer from "../Components/Core/Footer.jsx";
import "../Styles/CartPage/Cart.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faEnvelopeOpen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { faRotateLeft } from "@fortawesome/free-solid-svg-icons";
import api from "../api.js";
import UniversalCard from "../Components/UniversalCard.jsx";
import FullscreenSpinner from "../Components/FullscreenSpinner.jsx";
import { toast } from "react-toastify";

const Cart = () => {
  const navigate = useNavigate();
  const [cartList, setCartList] = useState([]);
  const [subtotal, setSubtotal] = useState("");
  const [selectedItem, setSelectedItem] = useState("1");
  const [showQuantityModal, setShowQuantityModal] = useState(false);
  const accessToken = localStorage.getItem("accessToken");
  const [cardImage, setCardImage] = React.useState([]);
  const [network, setNetwork] = useState(true);
  const [adding, setAdding] = useState(false);
  const userId = localStorage.getItem("accessToken");
  const [cartItemsCount, setCartItemsCount] = useState(0);
  const [loadingItemId, setLoadingItemId] = useState(null);

  useEffect(() => {
    if (!accessToken) {
      navigate("/login");
    } else {
      try {
        JSON.parse(accessToken);
      } catch (error) {
        console.error("Invalid access token format:", error);
        localStorage.removeItem("accessToken");
        navigate("/");
      }
    }
  }, [accessToken]);

  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        const res = await api.get(
          `/user_api/product/get-all-product-list?access_token=${JSON.parse(
            accessToken
          )}`
        );
        // console.log("response data: ", res.data);
        if (res.data.status === "success") {
          setNetwork(false);
          setCardImage(res.data.product_list);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchAllProducts();
  }, []);

  const fetchAllProducts = async () => {
    window.scrollTo({
      // Scroll to top after fetching products
      top: 0,
      behavior: "smooth", // optional for smooth scrolling
    });
    setAdding(true);
    try {
      const res = await api.get(
        `/user_api/product/get-all-product-list?access_token=${JSON.parse(
          accessToken
        )}`
      );
      console.log("response data: ", res.data);
      setCardImage(res.data.product_list);
      getCartList(); // Refresh cart after fetching products
    } catch (error) {
      console.log(error);
    } finally {
      setAdding(false);
    }
  };

  useEffect(() => {
    getCartList();
  }, []);

  const getCartList = async () => {
    try {
      const response = await api.get(
        `/user_api/cart/get-cart-details?access_token=${JSON.parse(
          accessToken
        )}`
      );
      console.log(response.data);

      setSubtotal(response.data.subtotal);
      setCartList(response.data.cart_details);
    } catch (error) {
      console.log("Error fetching cart:", error);
    }
  };

  const handleQuantityChange = async (itemId, quantity) => {
  setLoadingItemId(itemId); 
  try {
    const res = await api.post("/user_api/cart/update-quantity", {
      row_id: itemId,
      qty: quantity,
    });

    console.log("Update quantity : ", res);
    if (res.data.status === "success") {
      getCartList();
    } else {
      toast.error(res.data.message);
    }
  } catch (error) {
    console.log("Error updating quantity:", error);
  } finally {
    setLoadingItemId(null); 
  }
};

  const handleRemoveItem = async (item) => {
    console.log(item);

    try {
      const res = await api.delete(
        `/user_api/cart/remove-cart-product?row_id=${item}`
      );
      console.log(res.data);

      getCartList();
      const countRes = await api.get(
        `/user_api/cart/count-cart-wishlist-items?access_token=${JSON.parse(
          userId
        )}`
      );
      if (countRes.data.status === "success") {
        setCartItemsCount(countRes.data.total_cart_items);
      }
    } catch (error) {
      console.log("Error deleting item:", error);
    } finally {
    }
  };
  return (
    <div id="wb-container" class="wb-effect10">
      {network && <FullscreenSpinner />}
      <Navbar cartCount={cartItemsCount} />
      <div data-content-region="header_bottom--global"></div>
      <div data-content-region="header_bottom"></div>

      <main
        className="body"
        id="main-content"
        role="main"
        data-currency-code="USD"
      >
        <div className="container">
          <div className="page">
            <div className="page-content" data-cart>
              <h1
                className="page-heading"
                data-cart-page-title
                style={{ fontWeight: "bold" }}
              >
                Your Cart ({cartList?.length} Items)
              </h1>

              <div data-cart-status></div>
              {cartList?.length > 0 ? (
                <>
                  <div className="cart_items_parent_div">
                    <div className="cart_items_div">
                      {cartList.map((item, i) => (
                        <div className="cart_item_container shadow">
                          <div className="cart_item_img_div">
                            <img
                              src={item.image_path[0]}
                              className="shadow"
                              style={{
                                border: "0.5px solid #ccc",
                                padding: "3px",
                                borderRadius: "10px",
                                height: "100%",
                                width: "100%",
                              }}
                            />
                          </div>
                          <div className="cart_item_Details_div">
                            <div className="cart_item_name_div">
                              <h5>{item.product_name}</h5>
                            </div>
                            {/* <div className='cart_item_price_div'>
                        <p className='Short_description'>this is a Product Description part this is product details part</p>
                      </div> */}
                            <div
                              className="cart_item_price_div"
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <div
                                className="cart_item_price_div"
                                style={{
                                  display: "flex",
                                  gap: "4px",
                                  alignItems: "center",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: "600",
                                    marginBottom: "0px",
                                    marginLeft: "0px",
                                  }}
                                  className="cart_item_price"
                                >
                                  AED {item.price}
                                </p>
                                <p
                                  style={{
                                    textDecoration: "line-through",
                                    marginBottom: "0px",
                                  }}
                                  className="cart_item_initial_price"
                                >
                                  {item.initial_cost}
                                </p>
                                <p
                                  style={{
                                    color: "green",
                                    marginBottom: "0px",
                                  }}
                                  className="cart_item_discount"
                                >
                                  {item.discout}% off
                                </p>
                              </div>
                              <div>
                                <button
                                  onClick={() => handleRemoveItem(item.id)}
                                  className="cart_item_remove_btn"
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </button>
                              </div>
                            </div>

                            <div className="cart_item_remove_div">
                              <div style={{ display: "flex", gap: "4px" }}>
                                <label style={{ fontWeight: "600" }}>
                                  Quantity:{" "}
                                </label>
                                {/* <select
                                  style={{
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    padding: "4px",
                                    border: "0.5px solid blue",
                                  }}
                                  className="cart_item_quantity"
                                  value={item.qty}
                                  onChange={(e) =>
                                    handleQuantityChange(
                                      item.id,
                                      e.target.value
                                    )
                                  }
                                >
                                  {[1, 2, 3, 4, 5, 6, 7].map((qty) => (
                                    <option key={qty} value={qty}>
                                      {qty}
                                    </option>
                                  ))}
                                </select> */}
                                <select
                                  style={{
                                    borderRadius: "10px",
                                    cursor: "pointer",
                                    padding: "4px",
                                    border: "0.5px solid blue",
                                    opacity:
                                      loadingItemId === item.id ? 0.6 : 1,
                                  }}
                                  className="cart_item_quantity"
                                  value={item.qty}
                                  onChange={(e) =>
                                    handleQuantityChange(
                                      item.id,
                                      e.target.value
                                    )
                                  }
                                  disabled={loadingItemId === item.id}
                                >
                                  {[1, 2, 3, 4, 5, 6, 7].map((qty) => (
                                    <option key={qty} value={qty}>
                                      {qty}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div style={{ display: "flex", gap: "4px" }}>
                                <label style={{ fontWeight: "600" }}>
                                  Attribute:{" "}
                                </label>
                                <span>{item.attribute}</span>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: "4px",
                                  alignItems: "center",
                                }}
                              >
                                <label style={{ fontWeight: "600" }}>
                                  Color:{" "}
                                </label>
                                <span
                                  style={{
                                    backgroundColor: `#${item.color}`,
                                    borderRadius: "100%",
                                    border: "0.5px solid #CCC",
                                  }}
                                  className="colour_design"
                                ></span>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <button
                                  onClick={() => handleRemoveItem(item.id)}
                                  className="cart_item_remove_btn1"
                                >
                                  <FontAwesomeIcon icon={faTrash} />{" "}
                                  <span> Remove</span>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                      {adding && <h2>new item is adding..</h2>}
                    </div>

                    <div className="cart_items_price_div">
                      <div className="cart_items_Price_list ">
                        <div className="Product_bill_details">
                          <div className="Product_bill_details_header">
                            PRODUCT BILL DETAILS
                          </div>
                          <div className="Product_bill_details_div">
                            <div className="Product_bill_details_name">
                              Subtotal
                            </div>
                            <div className="Product_bill_details_price">
                              AED {subtotal}
                            </div>
                          </div>
                          <div className="Product_bill_details_div">
                            <div className="Product_bill_details_name">
                              Shipping
                            </div>
                            <div className="Product_bill_details_price">
                              AED 0
                            </div>
                          </div>
                          {/* <div className="Product_bill_details_div">
                            <div className="Product_bill_details_name">Tax</div>
                            <div className="Product_bill_details_price">
                              AED 5.00
                            </div>
                          </div> */}
                          {/* <hr style={{ margin: "0px" }} />
                          <div className="Product_bill_details_div">
                            <div className="Product_bill_details_name">
                              Total
                            </div>
                            <div className="Product_bill_details_price">
                              AED 115.00
                            </div>
                          </div> */}
                        </div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <button
                          className="place_order_btn"
                          onClick={() => {
                            navigate("/checkout");
                          }}
                        >
                          Checkout
                        </button>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <h3 tabIndex="0">Your cart is empty</h3>
                </>
              )}
            </div>
          </div>
        </div>

        <div
          id="modal"
          className="modal"
          data-reveal
          data-prevent-quick-search-close
        >
          <button className="modal-close" type="button" title="Close">
            <span className="aria-description--hidden">Close</span>
            <span aria-hidden="true">&#215;</span>
          </button>
          <div className="modal-content"></div>
          <div className="loadingOverlay"></div>
        </div>

        <div
          id="alert-modal"
          className="modal modal--alert modal--small"
          data-reveal
          data-prevent-quick-search-close
        >
          <div className="alert-icon error-icon">
            <span className="icon-content">
              <span className="line line-left"></span>
              <span className="line line-right"></span>
            </span>
          </div>

          <div className="alert-icon warning-icon">
            <div className="icon-content">!</div>
          </div>

          <div className="modal-content"></div>

          <div className="button-container">
            <button type="button" className="confirm button" data-reveal-close>
              OK
            </button>
            <button type="button" className="cancel button" data-reveal-close>
              Cancel
            </button>
          </div>
        </div>
      </main>
      <UniversalCard
        Heading={"RECOMMANDED FOR YOU"}
        CardData={cardImage}
        refreshCardData={fetchAllProducts}
        setCartItemsCount={setCartItemsCount}
      />
      <Footer />
    </div>
  );
};

export default Cart;
